import { Plus, Loader2 } from "lucide-react";
import { useNavigate } from "react-router";
import { useCategories, useCreateCategory } from "@/hooks/api";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export function CategoriesPage() {
  const { data: categories, isLoading } = useCategories();
  const createCategory = useCreateCategory();
  const navigate = useNavigate();

  const handleCreate = async () => {
    const cat = await createCategory.mutateAsync({
      name: "Ny kategori",
      description: "",
      color: "#6366f1",
    });
    navigate(`/categories/${cat.id}`);
  };

  if (isLoading) {
    return <div className="flex items-center justify-center py-12"><Loader2 className="h-6 w-6 animate-spin text-admin-text-subtle" /></div>;
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <Button onClick={handleCreate} size="sm" disabled={createCategory.isPending}>
          <Plus className="h-4 w-4" />
          Ny kategori
        </Button>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
        {(categories ?? []).map((cat) => (
          <Card
            key={cat.id}
            className="cursor-pointer hover:border-admin-primary/50 transition-colors"
            onClick={() => navigate(`/categories/${cat.id}`)}
          >
            <CardContent className="p-4 space-y-2">
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full shrink-0" style={{ backgroundColor: cat.color ?? "#6366f1" }} />
                <h3 className="font-semibold">{cat.name}</h3>
              </div>
              {cat.description && (
                <p className="text-sm text-admin-text-secondary line-clamp-2">{cat.description}</p>
              )}
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
